/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconSearch/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconSearch({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconSearch",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill = "#323232"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconSearch.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-1wWzfa': alignSelf,'--mt-2-1wWzfa': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-1wWzfa': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-1wWzfa': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-1wWzfa': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-1wWzfa': opacity,'--w-10-1wWzfa': typeof width === 'number' ? `${width}px` : width,'--h-11-1wWzfa': typeof height === 'number' ? `${height}px` : height,'--a-7-1wWzfa': isAnimated ? animation : "none",'--sd-8-1wWzfa': isAnimated ? strokeDashoffset : 0,'--sd-9-1wWzfa': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="TysiaIconSearch.SvgPath"
  data-view-path={viewPath}
 d="M15.5 14h-.79l-.28-.27A6.471 6.471 0 0016 9.5 6.5 6.5 0 109.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
 style={{'--f-12-1wWzfa': fill}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}